<template>
  <smd-one-col-layout>
    <div class="m-root-services-find-service__cards m-t-15 m-b-20">
      <smd-square-card has-text-string
                       v-for="card in $options.ServicesCardItem"
                       :class="{'smd-square-card--disabled': card.disabled}"
                       :item="card"
                       :key="card.labelId"
                       @selected="handleCardSelection(card.labelId)">
        <div class="p-t-10 text-center">
          <span class="m-services-card-title p-t-10 Body3">
            {{ getTitle(card) }}
          </span>
          <div class="m-services-card-subtitle Body3">
            {{ getSubTitle(card) }}
          </div>
        </div>
      </smd-square-card>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import RootServicesFindServicesMixin from '../root-services-find-services-mixin';

  export default {
    name: "m-root-services-find-service",
    mixins: [RootServicesFindServicesMixin]
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .m-root-services-find-service__cards {
    @include make-grid-cols(repeat(2, 1fr));
    grid-gap: space(s) + 2;

    .Label1 {
      font-size: 14px;
    }

    .disabled {
      opacity: 0.5;
    }

    .smd-square-card--disabled {
      .m-services-card-title,
      .m-services-card-subtitle {
        opacity: 0.4;
      }
    }
  }
</style>